import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as campaignListActions from '../../../redux/actions/CampaignListsActions';
import * as suggestionActions from '../../../redux/actions/SuggestionsActions';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import CampaignListParticipantsTable from './CampaignListParticipantsTable';
import CampaignListInfo from './CampaignListInfo';
import CampaignListReportModal from './CampaignListReportModal';
import AddCampaignRecipientModal from '../campaignsCommon/AddCampaignRecipientModal';
import PendingParticipantsModal from './PendingParticipantsModal';
import { toastr } from 'react-redux-toastr';
import { getRequest } from '../../../lib/apiUtils';
import { getLocationDepartment, formatNumber } from '../../../lib/utils';
import { PermissionTypes, CampaignListTypes, RecipientTypes } from '../../../lib/systemVariables';

class CampaignListDetailsPage extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      campaignListId: this.props.match.params.id,
      showModals: {
        editCampaignListModal: false,
        addRecipientModal: false,
        pendingParticipantsModal: false,
        reportModal: false
      }
    }
  }

  componentWillMount() {
    if (this.state.campaignListId) {
      this.getDetails();
      this.props.actions.getCampaignListAllParticipants(this.state.campaignListId);
    }
  }

  componentWillUnmount() {
    this.props.actions.clearCampaignListDetails();

    const navHistory = this.props.history;
    if (navHistory.action === 'POP' && navHistory.location.pathname === "/campaigns/lists") {
      navHistory.replace({ state: { ...navHistory.location.state, preserveData: true } });
    } else {
      navHistory.replace({ state: { ...navHistory.location.state, preserveData: false } });
    }
  }

  async getDetails() {
    await this.props.actions.getCampaignListDetails(this.state.campaignListId);
    if (!this.props.details.success) {
      toastr.error("Something went wrong!", `We were unable to retrieve campaign list details.  Please try again.`);
    }
  } 

  async getParticipantsForExport(params) {
    return await getRequest(`/campaignLists/${this.state.campaignListId}/participants/report`, params, []);
  }

  async addListParticipants(bypassError, recipientIds, addToActiveCampaign, reloadListDetails) {
    await this.props.actions.addCampaignListParticipants(this.state.campaignListId, recipientIds.length ? recipientIds : [recipientIds], bypassError, addToActiveCampaign, reloadListDetails);
    if (this.props.newParticipant.success) {
      this.props.actions.getCampaignListParticipants(this.state.campaignListId, 1, this.props.participantsTable.resultsView, this.props.participantsTable.sort);
      this.props.actions.getCampaignListAllParticipants(this.state.campaignListId);
    }
  }

  async removeListParticipant(recipientId, bypassError, removeFromActiveCampaign) {
    await this.props.actions.removeCampaignListParticipant(this.state.campaignListId, recipientId, bypassError, removeFromActiveCampaign);

    if (this.props.participantsTable.removing.success) {
      this.props.actions.getCampaignListAllParticipants(this.state.campaignListId);
    }
  }


  render() {
    const campaignList = this.props.details.data;
    
    return (
      <div className="page campaign-list">
        <div className="subheader campaign-header">
          <div className="container flex-justify">
            <div className="full-width">
              {this.props.details.loading ? <LoadingSpinner height="20" />
                : (campaignList.campaignListId && <div>
                  <CampaignListInfo
                    campaignList= {campaignList}/>
                </div>)}
            </div>
            <div className="back-link">
              <i className="icon ion-android-arrow-back middle medium-text"></i>
              <span className="link-text small-text" onClick={this.props.history.goBack}>
                Back to Campaign Lists
              </span>
            </div>
          </div>
        </div>
        {campaignList.campaignListId && <div>
          <div className="campaigns-filters">
            <div className="container flex-center flex-justify">
              <p className="medium-text">Participants <span className="total-tag">{formatNumber(this.props.participantsTable.data.totalCount)}</span></p>
              <div className="flex">
              {/* {this.props.userPermissions.report && 
                <ExportButton
                    disabled={!(this.props.participantsTable.data.records && this.props.participantsTable.data.records.length)}
                    exportHeaders={[
                      { label: "Name", value: "displayName", default: "" },
                      { label: "Phone", value: "phoneNumber", default: "" },
                      { label: "Address", value: "addressDisplay", default: "" }
                    ]}
                    fileName={campaignList.name ? campaignList.name.split(" ").join("-") : "Campaign-list"}
                    getDataForExport={this.getParticipantsForExport.bind(this)} />
                } */}
                {this.props.userPermissions.report &&
                  <button className="btn btn-accent2 icon-right btn-small" onClick={this.toggleModal.bind(this, "reportModal")}>New Report</button>}
                {this.props.userPermissions.manage &&
                  <button className="btn btn-accent2 icon-right btn-small" onClick={this.toggleModal.bind(this, "addRecipientModal")}>Add Participant</button>}
                {this.props.userPermissions.manage && campaignList.pendingMembersCount > 0 &&
                  <button className="btn btn-accent2 icon-right btn-small"
                    onClick={() => {
                      this.props.actions.getCampaignListPendingParticipants(campaignList.campaignListId);
                      this.toggleModal("pendingParticipantsModal");
                    }}>Add Pending Participants ({formatNumber(campaignList.pendingMembersCount)})</button>}
              </div>
            </div>
          </div>

          <CampaignListParticipantsTable
            {...this.props.participantsTable}
            campaignListName={campaignList.name}
            campaignListId={campaignList.campaignListId}
            isExternalOrgCampaignList={campaignList.campaignListType === CampaignListTypes.External && campaignList.organizationName}
            updateTable={this.props.actions.updateParticipantsTable}
            getCampaignListParticipants={(...tableProps) => this.props.actions.getCampaignListParticipants(this.state.campaignListId, ...tableProps || {})}
            managePermission={this.props.userPermissions.manage}
            removeParticipant={this.removeListParticipant.bind(this)} />

        </div>}

        <AddCampaignRecipientModal
          campaignList={campaignList}
          show={this.state.showModals.addRecipientModal}
          close={this.toggleModal.bind(this, "addRecipientModal")}
          {...this.props.newParticipant}
          recipientType={!this.props.userPermissions.institutions
            ? RecipientTypes.Individual
            : null}
          recipientTypes={this.props.systemSettings.otherSettings.recipientTypes}
          recipientSuggestions={this.props.recipientSuggestions}
          getRecipientSuggestions={(name, otherInfo = {}) => this.props.actions.getRecipientSuggestions(name, {
            departments: [getLocationDepartment(this.props.locationGroups, campaignList.locationId)],
            ...(!campaignList.organizationName
              ? { locationId: campaignList.locationId } : {}),
            ...((campaignList.campaignListType === CampaignListTypes.External || !this.props.userPermissions.institutions)
              ? { applicantType: RecipientTypes.Individual } 
              : {}),
            ...otherInfo
          }, this.props.allParticipants.data.map(p => p.applicantId))}
          locationId={campaignList.locationId}
          clearRecipientSuggestions={this.props.actions.clearRecipientSuggestions}
          addRecipient={this.addListParticipants.bind(this)} />

        <PendingParticipantsModal
          show={this.state.showModals.pendingParticipantsModal}
          close={this.toggleModal.bind(this, "pendingParticipantsModal")}
          campaignListName={campaignList.name}
          pendingParticipants={this.props.pendingParticipants}
          {...this.props.newParticipant}
          addParticipants={(...props) => this.addListParticipants(...props, true)} />

        <CampaignListReportModal
          campaignListName={campaignList.name}
          getDataForExport={this.getParticipantsForExport.bind(this)}
          show={this.state.showModals.reportModal}
          close={() => this.toggleModal("reportModal")}
        />

      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...state.campaignListDetails,
    participantsTable: state.campaignListParticipantsTable,
    recipientSuggestions: state.suggestions.recipientSuggestions,
    systemSettings: state.settings.systemSettings.data,
    userPermissions: {
      admin: state.userProfile.profile.data.roleId === 1,
      manage: state.userProfile.permissions.data.indexOf(PermissionTypes.CampaignAndListsManage) >= 0,
      report: state.userProfile.permissions.data.indexOf(PermissionTypes.Reporting) >= 0,
      institutions: state.userProfile.permissions.data.indexOf(PermissionTypes.InstitutionsManage) >= 0
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...suggestionActions, ...campaignListActions }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignListDetailsPage);


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/CampaignListDetailsPage.jsx